const kAppTitle = "管理システム";
const kMsgNotAdmin = "本操作はスーパーユーザー権限が必要です。";

const defs = {
  // account
  // string
  kAppTitle,
  kMsgNotAdmin,

  // keys of authenticate info
  kKeyIsRemember: "rememberMe",
  kKeyAuthInfo: "authInfo",
  kKeyLoginUser: "loginUser",
  kKeyIsAuthenticated: "isAuthenticated",

  kAct_ViewContactUsOpen: "dlg-contact-us-open", //
  kAct_ViewContactUsCancel: "dlg-contact-us-cancel", //
  kAct_ExecContactUsSend: "exec-contact-us-send", //

  // 問合せemail
  kContactUsEmail: "xh@zerone-inf.com",
};

// リアルタイム契約
// テスト環境

export default defs;
export { defs };
